import React from 'react';
import { useStore } from '../../store/useStore';
import { Input, Textarea } from '../ui';
import { Target, TrendingUp, Flag } from 'lucide-react';

export function M16_Objectives() {
  const { objectives, setObjectives } = useStore();

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setObjectives({ [e.target.name]: e.target.value });
  };

  const calculateProgress = (current: string, goal: string) => {
    const c = parseFloat(current) || 0;
    const g = parseFloat(goal) || 1; // prevent div/0
    return Math.min(Math.round((c / g) * 100), 100);
  };

  const renderProgressCard = (title: string, nameAtual: string, nameGoal: string, valAtual: string, valGoal: string, isCurrency = false) => {
    const progress = calculateProgress(valAtual, valGoal);
    return (
      <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm space-y-4">
        <h4 className="font-semibold text-gray-900 text-sm">{title}</h4>
        
        <div className="grid grid-cols-2 gap-4">
           <div>
              <Input 
                  label="Hoje" 
                  name={nameAtual} 
                  value={valAtual} 
                  onChange={handleTextChange} 
                  placeholder={isCurrency ? "0,00" : "0"} 
                  className={isCurrency ? "pl-9" : ""}
              />
              {isCurrency && <span className="absolute left-[33px] top-[73px] text-gray-500 font-medium text-sm border-r border-gray-200 pr-1">R$</span>}
           </div>
           <div>
              <Input 
                  label="Meta" 
                  name={nameGoal} 
                  value={valGoal} 
                  onChange={handleTextChange} 
                  placeholder={isCurrency ? "0,00" : "0"} 
                  className={isCurrency ? "pl-9" : ""}
              />
              {isCurrency && <span className="absolute left-[193px] lg:left-[calc(50%+33px)] xl:left-[calc(50%+33px)] top-[73px] text-gray-500 font-medium text-sm border-r border-gray-200 pr-1 hidden group">R$</span>}
           </div>
        </div>

        <div className="pt-2">
           <div className="flex justify-between items-center mb-1 text-xs font-medium">
             <span className="text-gray-500">Jornada</span>
             <span className={progress >= 100 ? "text-green-600" : "text-indigo-600"}>{progress}%</span>
           </div>
           <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
             <div className={`h-2.5 rounded-full transition-all duration-500 ${progress >= 100 ? 'bg-green-500' : 'bg-indigo-600'}`} style={{ width: `${progress}%` }}></div>
           </div>
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-gray-900">Objetivos & Metas</h2>
        <p className="text-gray-500 mt-1">
          Monitoramento visual da jornada: Onde estamos hoje X Onde queremos chegar.
        </p>
      </div>

      <div className="bg-gray-50/50 rounded-xl border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-200 bg-white flex items-center gap-2">
          <Target size={18} className="text-indigo-600" />
          <h3 className="font-semibold text-gray-900">Curto Prazo (Próximos 3 meses)</h3>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
           {renderProgressCard(
             "Faturamento Mensal", 
             "meses3FaturamentoAtual", "meses3Faturamento", 
             objectives.meses3FaturamentoAtual, objectives.meses3Faturamento, 
             true
           )}
           {renderProgressCard(
             "Volume de Leads / Mês", 
             "meses3LeadsAtual", "meses3Leads", 
             objectives.meses3LeadsAtual, objectives.meses3Leads
           )}
           {renderProgressCard(
             "Vendas Fechadas / Mês", 
             "meses3VendasAtual", "meses3Vendas", 
             objectives.meses3VendasAtual, objectives.meses3Vendas
           )}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-2">
          <Flag size={18} className="text-rose-500" />
          <h3 className="font-semibold text-gray-900">Longo Prazo Estratégico (Próximos 12 meses)</h3>
        </div>
        <div className="p-6">
           <Textarea 
                label="Qual o grande marco para daqui 1 ano?" 
                name="meses12Estrategicos" 
                value={objectives.meses12Estrategicos} 
                onChange={handleTextChange} 
                placeholder="Ex: Abrir filial em outra cidade, lançar novo produto, dobrar o time comercial..." 
                className="min-h-[150px]"
           />
        </div>
      </div>

    </div>
  );
}
